import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Philosophy from "@/pages/Philosophy";
import Pantry from "@/pages/Pantry";
import { RecipesPreview, RecipePreviewDetail } from "@/pages/Recipes";
import Shop from "@/pages/Shop";
import Login from "@/pages/Login";
import ReaderHome from "@/pages/ReaderHome";
import RecipeReader from "@/pages/RecipeReader";
import MenuPage from "@/pages/MenuPage";
import Downloads from "@/pages/Downloads";
import AdminSampler from "@/pages/AdminSampler";
import ReaderPantry from "@/pages/ReaderPantry";
import Foundations from "@/pages/Foundations";
import TechniquePage from "@/pages/TechniquePage";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import FAQ from "@/pages/FAQ";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

const TOAST_OPTIONS = {
  style: { background: "#1F3B2D", color: "#F5EEDC", border: "1px solid #B8873B" },
};

function Shell({ children }) {
  const loc = useLocation();
  const hideFooter = loc.pathname.startsWith("/payment");
  return (
    <>
      <Nav />
      {children}
      {!hideFooter && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-center" toastOptions={TOAST_OPTIONS} />
        <Shell>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/philosophy" element={<Philosophy />} />
            <Route path="/pantry" element={<Pantry />} />
            <Route path="/preview" element={<RecipesPreview />} />
            <Route path="/preview/:slug" element={<RecipePreviewDetail />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/login" element={<Login />} />
            <Route path="/read" element={<ReaderHome />} />
            <Route path="/read/recipe/:slug" element={<RecipeReader />} />
            <Route path="/read/menu/:slug" element={<MenuPage />} />
            <Route path="/read/pantry" element={<ReaderPantry />} />
            <Route path="/read/foundations" element={<Foundations />} />
            <Route path="/read/techniques/:slug" element={<TechniquePage />} />
            <Route path="/read/downloads" element={<Downloads />} />
            <Route path="/admin/sampler" element={<AdminSampler />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
        </Shell>
      </BrowserRouter>
    </div>
  );
}
